/* Version: 3.5.137 */
'use client';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState } from 'react';
import useDerivedFlag from './useDerivedFlag.js';

function useDerivedState(initialValue, derivedValue) {
  // We have to call this no matter what, but we only use it if value is local state
  var _useState = useState(initialValue),
    _useState2 = _slicedToArray(_useState, 2),
    stateValue = _useState2[0],
    setStateValue = _useState2[1];

  // this flag is set to true if derivedValue is not undefined, or if it ever becomes defined
  // once it is set to true, it will never turn back to false for the lifetime of the component
  var isDerived = useDerivedFlag(derivedValue, function () {
    return setStateValue(initialValue);
  });
  function noopUpdater() {
    /* not using noop util here as we don't want a return value */
  }
  var value = isDerived ? derivedValue : stateValue;
  var updater = isDerived ? noopUpdater : setStateValue;
  return [value, updater, isDerived];
}

export { useDerivedState as default };
